import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { useCallback } from "react";
import { createContainer } from "unstated-next";
import useDeleteComment from "../graphql/mutations/useDeleteComment";
const PostPageCommentContext = createContainer((initialState)=>{
    const showSnackbar = useSnackbar();
    const deleteCommentMutation = useDeleteComment();
    const deleteComment = useCallback(()=>{
        if (!initialState) {
            showSnackbar.error();
            return;
        }
        deleteCommentMutation(initialState);
    }, [
        deleteCommentMutation,
        initialState,
        showSnackbar
    ]);
    return {
        deleteComment
    };
});
export const usePostPageComment = PostPageCommentContext.useContainer;
export const PostPageCommentProvider = PostPageCommentContext.Provider;
